// src/composables/useProfilePassword.js
import { ref } from '@vue/composition-api'
import store from '@/store'
import analytics from '@/@core/utils/analytics'
import constants from '@/constants'
import { PURGE_AUTH } from '@/store/modules/auth.module'
import { apiToastSuccess, apiToastWarning } from '@/@core/utils/toast'

export function useProfilePassword() {
  // --- Reactive State ---
  const passwordValueOld = ref('')
  const newPasswordValue = ref('')
  const retypePassword = ref('')
  const saving = ref(false)

  // --- Methods ---
  async function savePassword(kpRequest, kpEndpoint, router) {
    if (newPasswordValue.value !== retypePassword.value) {
      apiToastWarning('Retype password miss match!')
      return { success: false }
    }
    saving.value = true
    try {
      const res = await kpRequest({
        ...kpEndpoint.profile.changePassword,
        payload: {
          oldPassword: passwordValueOld.value,
          password: newPasswordValue.value,
          password2: retypePassword.value,
        },
      })
      apiToastSuccess(res.data.message)
      analytics.track(constants.TRACKS.ACTIONS.SAVE_PROFILE_SETTINGS_PASSWORD)
      store.commit(PURGE_AUTH)
      router.push({ name: 'auth-login' })
      return { success: true }
    } catch {
      return { success: false }
    } finally {
      saving.value = false
    }
  }

  function resetForm() {
    passwordValueOld.value = ''
    newPasswordValue.value = ''
    retypePassword.value = ''
  }

  return {
    passwordValueOld,
    newPasswordValue,
    retypePassword,
    saving,
    savePassword,
    resetForm,
  }
}
